import React from "react"
import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Nav,
  } from 'reactstrap'
  import { useSelector } from 'react-redux'
  import { Link } from 'react-router-dom'
  import '../../../styling/glyphicons/glyphicons.css'
import { DefaultState } from "../../../types"


  const ExtensionMenu = () => {
    const extensionMenuItems = useSelector((state: DefaultState) => state.server.extensions)
    return ( extensionMenuItems.length > 0 ?
      <UncontrolledDropdown nav inNavbar>
        <DropdownToggle nav caret className='glyphicons glyphicons-plus' />
        <Nav>
          <DropdownMenu>
            {extensionMenuItems.map((item, index) => {
              return (
                <DropdownItem key={index}>
                  <Link to={item.val} className='glyphicons glyphicons-link' style={{whiteSpace: "normal", height: "min-content", wordBreak: 'break-all'}}>
                    <span>{item.what}</span>
                  </Link>
                </DropdownItem>
              )
            })}
          </DropdownMenu>
        </Nav>
      </UncontrolledDropdown>
      : <></>
    )
  }

  export default ExtensionMenu